import { SelectStatus } from '@types';

const getSelectedStatus = (selectedSize: number, maxSize: number) => {
  if (selectedSize === 0) return SelectStatus.none;
  if (selectedSize >= maxSize) return SelectStatus.all;
  return SelectStatus.part;
};

export default getSelectedStatus;
